import { textDrawOffsetX, textLayoutOffsetY, mat4Allocate, TEXT_NUMBER_TYPE } from "@visactor/vrender-core";

import { Base3dPicker } from "../common/base-3d-picker";

export class DefaultCanvasTextPicker extends Base3dPicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "text", this.numberType = TEXT_NUMBER_TYPE;
    }
    contains(text, point, params) {
        const {pickContext: pickContext} = null != params ? params : {};
        if (!pickContext) return !1;
        const bounds = text.AABBBounds;
        if (!pickContext.camera) return !!bounds.containsPoint(point);
        pickContext.highPerformanceSave();
        const textAttribute = text.getGraphicTheme(), {keepDirIn3d: keepDirIn3d = textAttribute.keepDirIn3d} = text.attribute, computed3dMatrix = !keepDirIn3d, data = this.transform(text, textAttribute, pickContext, computed3dMatrix), {x: x, y: y, z: z, lastModelMatrix: lastModelMatrix} = data;
        this.canvasRenderer.z = z;
        let pickPoint = point;
        if (pickContext.camera) {
            pickPoint = point.clone();
            const globalMatrix = text.parent.globalTransMatrix;
            pickPoint.x = globalMatrix.a * point.x + globalMatrix.c * point.y + globalMatrix.e, 
            pickPoint.y = globalMatrix.b * point.x + globalMatrix.d * point.y + globalMatrix.f;
        }
        let picked = !1;
        return this.canvasRenderer.drawShape(text, pickContext, x, y, {}, null, ((context, symbolAttribute, themeAttribute) => {
            if (picked) return !0;
            const {fontSize: fontSize = textAttribute.fontSize, textBaseline: textBaseline = textAttribute.textBaseline, textAlign: textAlign = textAttribute.textAlign} = text.attribute, bounds = text.AABBBounds, height = bounds.height(), width = bounds.width(), offsetY = textLayoutOffsetY(textBaseline, height, fontSize), offsetX = textDrawOffsetX(textAlign, width);
            return context.rect(offsetX + x, offsetY + y, width, height, z), picked = context.isPointInPath(pickPoint.x, pickPoint.y), 
            picked;
        }), ((context, symbolAttribute, themeAttribute) => picked)), this.canvasRenderer.z = 0, 
        pickContext.modelMatrix !== lastModelMatrix && mat4Allocate.free(pickContext.modelMatrix), 
        pickContext.modelMatrix = lastModelMatrix, pickContext.highPerformanceRestore(), 
        picked;
    }
}
//# sourceMappingURL=text-picker.js.map
